import React from 'react';
import styles from './CustomMixinButton.module.scss';
export var CustomMixinButton = function () {
    return React.createElement("button", { className: styles.button }, "Custom Button");
};
//# sourceMappingURL=CustomMixinButton.js.map